import withStyles from '@mui/styles/withStyles';
import Typography from '@classify/react-core-components/Typography';

const styles = /* istanbul ignore next */ ({ spacing }) => ({
  root: {
    padding: spacing(1.5),
  },
});

const CardActionLabel = ({ children, classes = {}, ...props }) => (
  <Typography {...props} className={classes.root} variant="body">
    {children}
  </Typography>
);

export default withStyles(styles)(CardActionLabel);
